import React from 'react'

import { Componente } from './styles'
import { ModalBaseProps } from './tipos'

export const ModalBase: React.FC<ModalBaseProps> = ({ children, ...rest }) => {
  return <Componente {...rest}>{children}</Componente>
}
